import { InputHTMLAttributes, forwardRef } from 'react';
import { cn } from '@/lib/utils';

interface AIMInputProps extends InputHTMLAttributes<HTMLInputElement> {}

export const AIMInput = forwardRef<HTMLInputElement, AIMInputProps>(
  ({ className, ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={cn('aim-input w-full', className)}
        {...props}
      />
    );
  }
);

AIMInput.displayName = 'AIMInput';
